// Utilities/cacheThunks.js
import { setCacheData, setLoading, setError } from './cacheSlice';

export const fetchWithCache = (key, fetchFn, cacheDuration) => async (dispatch, getState) => {
  const { cache } = getState();
  
  // Check if we have valid cache
  const cacheTime = cache.timestamps[key];
  const cachedData = cache.data[key];
  
  const isCacheValid = (cacheTime) => {
    if (!cacheTime) return false;
    const age = (Date.now() - cacheTime) / (1000 * 60);
    return age < cacheDuration;
  };
  
  // Return cached data if valid
  if (cachedData && isCacheValid(cacheTime)) {
    return cachedData;
  }
  
  dispatch(setLoading(true));
  dispatch(setError(null));
  
  try {
    const response = await fetchFn(); // Execute the provided fetch function
    const data = response.data; // Axios wraps the response in a data property
    
    // Validate data format
    if (data.code === 200 && Array.isArray(data.data)) {
      dispatch(setCacheData({ key, data: data.data }));
      return data.data;
    } else {
      throw new Error('Invalid data format');
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    const errorMessage = error.response?.data?.message || error.message;
    dispatch(setError(errorMessage));
    
    // Fallback to cache if available (even if expired)
    if (cachedData) {
      return cachedData;
    }
    
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
};